import React from 'react'
import {CheckCircleIcon, XCircleIcon, InformationCircleIcon, ExclamationCircleIcon, XIcon} from '@heroicons/react/solid'
import {TransProps} from '@lingui/react'


// Type
export type typeAlert = {
    type: 'warning' | 'success' | 'error' | 'info'
    title: React.ReactElement<TransProps> | string
    messages?:  React.ReactElement<TransProps>[]
    className?: string
    onCloseButton?: () => void
    textColor?: string
}


// Component
export const Alert: React.FC<typeAlert> = ({type, title, messages, className, onCloseButton, textColor}) => {

    let color
    let bgColor50
    let bgColor100
    let textColor400
    let textColor500
    let textColor700
    let textColor800

    switch (type) {
        case 'warning':
            color = 'yellow'
            bgColor50 = 'bg-yellow-50'
            bgColor100 = 'hover:bg-yellow-100'
            textColor400 = 'text-yellow-400'
            textColor500 = 'text-yellow-500'
            textColor700 = 'text-yellow-700'
            textColor800 = 'text-yellow-800'
            break
        case 'success':
            color = 'green'
            bgColor50 = 'bg-green-50'
            bgColor100 = 'hover:bg-green-100'
            textColor400 = 'text-green-400'
            textColor500 = 'text-green-500'
            textColor700 = 'text-green-700'
            textColor800 = 'text-green-800'
            break
        case 'error':
            color = 'red'
            bgColor50 = 'bg-red-50'
            bgColor100 = 'hover:bg-red-100'
            textColor400 = 'text-red-400'
            textColor500 = 'text-red-500'
            textColor700 = 'text-red-700'
            textColor800 = 'text-red-800'
            break
        case 'info':
            color = 'gray'
            bgColor50 = 'bg-gray-50'
            bgColor100 = 'hover:bg-gray-100'
            textColor400 = 'text-gray-400'
            textColor500 = 'text-gray-500'
            textColor700 = 'text-gray-700'
            textColor800 = 'text-gray-800'
            break
        default:
            color = 'blue'
            bgColor50 = 'bg-blue-50'
            bgColor100 = 'hover:bg-blue-100'
            textColor400 = 'text-blue-400'
            textColor500 = 'text-blue-500'
            textColor700 = 'text-blue-700'
            textColor800 = 'text-blue-800'
    }


    const mainClassed = [`rounded-md ${bgColor50} p-4`, className].join(' ')

    return (

        <div className={mainClassed}>
            <div className="flex">

                <div className="flex-shrink-0">
                    {type === 'success' ? <CheckCircleIcon className={`h-5 w-5 ${textColor400}`} aria-hidden="true" /> : null}
                    {type === 'error' ? <XCircleIcon className={`h-5 w-5 ${textColor400}`} aria-hidden="true" /> : null}
                    {type === 'warning' ? <ExclamationCircleIcon className={`h-5 w-5 ${textColor400}`} aria-hidden="true" /> : null}
                    {type === 'info' ? <InformationCircleIcon className={`h-5 w-5 ${textColor400}`} aria-hidden="true" /> : null}
                </div>

                <div className="ml-3">

                    <h3 className={`text-sm font-medium ${textColor800}`}>
                        {title}
                    </h3>

                    {messages
                        ? <div className={`mt-2 text-sm ${textColor700}`}>
                            <ul className="list-disc pl-5 space-y-1">
                                {messages?.map((item,index) => <li key={index}>{item}</li>)}
                            </ul>
                        </div>
                        : null
                    }

                </div>

                {onCloseButton
                    ? <div className="ml-auto pl-3">
                        <div className="-mx-1.5 -my-1.5">
                            <button
                                type="button"
                                className={`inline-flex ${bgColor50} rounded-md p-1.5 ${textColor500} ${bgColor100} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-${color}-50 focus:ring-${color}-600`}
                            >
                                <span className="sr-only">Dismiss</span>
                                <XIcon onClick={() => onCloseButton()} className="h-5 w-5" aria-hidden="true" />
                            </button>
                        </div>
                    </div>
                    : null
                }

            </div>
        </div>
    )
}

